import Swiper from 'swiper/bundle';
import $ from 'jquery';


new Swiper('.home-slider', {
    slidesPerView: 2,
    allowTouchMove : true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
            return '<span class="' + className + '"></span>';
        },
    },
    navigation: {
        nextEl: '.home-slider__nav--next',
        prevEl: '.home-slider__nav--prev',
    },
    breakpoints : {
        550: {
            slidesPerView: 3,
        },
        1100: {
            slidesPerView: 4,
        }
    }
});
